const GridLayouts = {
  DEFAULT: "default",
  TWO_COLUMN: "twoColumn",
};

export default GridLayouts;
